import React, { Component }  from 'react'
import Modal from "react-modal";
import UserForm from "./UserForm"
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};

const UserModal = ({open, onClose, editingUser, user, onSave}) => {
  
  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Example Modal"
      className="react-modal"
    >
      <UserForm
        onClose={onClose}
        onSave={onSave}
        editingUser={editingUser}
        user={user}
      />
    </Modal>
  )
}

export default UserModal